import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import TimelapseDetail from "@/pages/TimelapseDetail";
import Shop from "@/pages/Shop";
import Portfolio from "@/pages/Portfolio";
import Weddings from "@/pages/Weddings";
import Collection from "@/pages/Collection";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Licensing from "@/pages/Licensing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Chrome({ children }) {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/payment");
  return (
    <>
      {!bare && <Navbar />}
      {children}
      {!bare && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App grain min-h-screen bg-obsidian text-neutral-100">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster theme="dark" position="bottom-right" richColors />
        <Chrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/weddings" element={<Weddings />} />
            <Route path="/timelapse/:id" element={<TimelapseDetail />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/collections/:slug" element={<Collection />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/licensing" element={<Licensing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/account" element={<Account />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </Chrome>
      </BrowserRouter>
    </div>
  );
}

export default App;
